/** Целые «подпиксели»: 1 px мира = 256. Мир считает только в них, дробей нет (GAME-02). */
export const FP = 256;

/** Пиксели → подпиксели. Только для чисел из данных (скорости, зоны); Math.round одинаков во всех браузерах. */
export const sub = (pixels: number): number => Math.round(pixels * FP);

/** Подпиксели → целые пиксели для рисования. */
export const toPixels = (subpixels: number): number => Math.floor(subpixels / FP);

export const clampInt = (value: number, low: number, high: number): number =>
  value < low ? low : value > high ? high : value;

/** Целый квадратный корень (вниз) — только целые операции, одинаково во всех браузерах. */
export function isqrt(value: number): number {
  if (value <= 0) return 0;
  let root = value;
  let next = divInt(root + 1, 2);
  while (next < root) {
    root = next;
    next = divInt(root + divInt(value, root), 2);
  }
  return root;
}

/** Целочисленное деление с отбрасыванием дробной части. */
export const divInt = (value: number, divisor: number): number => Math.trunc(value / divisor);
